<div class="app-filename-input-container">
    <input [formControl]="nameForm" matInput>
    <span class="filename-suffix" *ngIf="fileNameSuffix"><fa-icon icon="pencil-alt" class="edit-icon" matTooltip="Endung bearbeiten" matTooltipPosition="left" (click)="onMakeSuffixEditable()"></fa-icon>{{fileNameSuffix}}</span>
</div>
